import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "flatpickr/dist/flatpickr.css";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { addSection } from "store/actions";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { Input, Textarea } from "components/shared/FormComponents";
import ImageUpload from "./ImageUpload";

const AddCategories = () => {
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [selectedIcon, setSelectedIcon] = useState({
    preview: null,
    path: "",
  });
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, sections, section } = useSelector(
    (state) => state.section
  );

  const [slider, setSlider] = useState([]);
  const [features, setFeatures] = useState([]);
  const [description, setDescription] = useState({});

  const [filteredCategories, setFilteredCategories] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);
  // updating categories dropdown
  useEffect(() => {
    setFilteredCategories(() =>
      sections.filter((i) => i?.title === "categories")
    );
  }, [sections]);
  const onSubmit = (data) => {
    console.log(data);
    data.image = `${process.env.REACT_APP_URL}/uploads/${selectedImage?.path
      ?.split("/")
      .pop()}`;
    data.icon = `${process.env.REACT_APP_URL}/uploads/${selectedIcon?.path
      ?.split("/")
      .pop()}`;
    console.log(data);
    dispatch(
      addSection({
        page: "categories-1",
        data: { section: { title: data.sectionTitle.en, ...data } },
        navigate: () => navigate("/categories"),
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addCategory"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"image"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedImage}
                      setSelectedImage={setSelectedImage}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"icon"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedIcon}
                      setSelectedImage={setSelectedIcon}
                    />
                  </div>
                </Col>
                <Row />
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="sectionTitle.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="sectionTitle.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="description"
                    name="sectionDescription.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="description"
                    name="sectionDescription.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <AddButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategories;
